var map = {
	"./": 2259,
	"./Abrafarma.png": 3929,
	"./BALTO.png": 1716,
	"./BALTObranco.png": 5939,
	"./EpocaNegocios.svg": 8925,
	"./Icon-Enviar.png": 6149,
	"./LOGO_CLINIC_FARMA_2022_2023.png": 3673,
	"./LOGO_PAGUE_MENOS.png": 2229,
	"./Pague_menos.png": 3771,
	"./Pague_menos_1.png": 7719,
	"./Path.png": 5757,
	"./Shutterstock_1280457310.png": 8945,
	"./Shutterstock_1940595922.png": 222,
	"./Shutterstock_2072813561.png": 23,
	"./Shutterstock_2101040086.png": 7668,
	"./Shutterstock_651777256.png": 5062,
	"./Shutterstock_776025448.jpg": 6155,
	"./Shutterstock_7760254483.png": 2656,
	"./Web": 8846,
	"./Web.js": 8846,
	"./Web.scss": 2028,
	"./background-first-container.png": 9467,
	"./chatVideo.MP4": 856,
	"./chatVideo.mp4": 9016,
	"./checklistDataSharing.png": 8772,
	"./combo-image.png": 6652,
	"./components/admin/Style": 1240,
	"./components/admin/Style.js": 1240,
	"./components/admin/admin": 9401,
	"./components/admin/admin.js": 9401,
	"./components/bnpl/Style": 9455,
	"./components/bnpl/Style.js": 9455,
	"./components/bnpl/bnpl": 8692,
	"./components/bnpl/bnpl.js": 8692,
	"./components/home/Style": 7628,
	"./components/home/Style.js": 7628,
	"./components/home/home": 85,
	"./components/home/home.js": 85,
	"./components/primaryCare/Style": 428,
	"./components/primaryCare/Style.js": 428,
	"./components/primaryCare/primaryCare": 4174,
	"./components/primaryCare/primaryCare.js": 4174,
	"./components/privacy/Style": 2235,
	"./components/privacy/Style.js": 2235,
	"./components/privacy/privacy": 7966,
	"./components/privacy/privacy.js": 7966,
	"./components/terms/Style": 9480,
	"./components/terms/Style.js": 9480,
	"./components/terms/terms": 5246,
	"./components/terms/terms.js": 5246,
	"./components/webFooter/Style": 3394,
	"./components/webFooter/Style.js": 3394,
	"./components/webFooter/webFooter": 3014,
	"./components/webFooter/webFooter.js": 3014,
	"./components/webHeader/Style": 584,
	"./components/webHeader/Style.js": 584,
	"./components/webHeader/webHeader": 2193,
	"./components/webHeader/webHeader.js": 2193,
	"./config/config": 7174,
	"./config/config.example": 5894,
	"./config/config.example.json": 5894,
	"./config/config.json": 7174,
	"./consent.png": 6552,
	"./consumidorModerno.png": 2845,
	"./dipirona1.png": 7801,
	"./dipirona2.webp": 7280,
	"./dipirona3.webp": 7331,
	"./dipirona4.webp": 974,
	"./email.svg": 3800,
	"./farmaciain.png": 9671,
	"./first_second_container.png": 7101,
	"./helpers/addChat": 9223,
	"./helpers/addChat.js": 9223,
	"./helpers/addFeedback": 7446,
	"./helpers/addFeedback.js": 7446,
	"./helpers/auth": 3662,
	"./helpers/auth.js": 3662,
	"./helpers/bnpl": 4176,
	"./helpers/bnpl.js": 4176,
	"./helpers/getClient": 8113,
	"./helpers/getClient.js": 8113,
	"./helpers/getQuestions": 1357,
	"./helpers/getQuestions.js": 1357,
	"./helpers/listChats": 6770,
	"./helpers/listChats.js": 6770,
	"./helpers/manageCart": 4389,
	"./helpers/manageCart.js": 4389,
	"./helpers/medicine": 6368,
	"./helpers/medicine.js": 6368,
	"./helpers/mockedProducts": 6752,
	"./helpers/mockedProducts.json": 6752,
	"./helpers/postChat": 1448,
	"./helpers/postChat.js": 1448,
	"./helpers/postOnDataLake": 5976,
	"./helpers/postOnDataLake.js": 5976,
	"./helpers/sendEmail": 6588,
	"./helpers/sendEmail.js": 6588,
	"./iStock-1280292736-1.png": 2426,
	"./index": 2259,
	"./index.css": 9555,
	"./index.js": 2259,
	"./logo-extrafarma.png": 4131,
	"./output-onlinepngtools(6).png": 1062,
	"./paguemenos.png": 468,
	"./saude_icon.png": 4732,
	"./sendEmailsList.png": 829,
	"./serviceWorker": 7001,
	"./serviceWorker.js": 7001,
	"./spacemoney.jpeg": 1923,
	"./tosse1.webp": 1581,
	"./tosse2.png": 6224,
	"./tosse3.png": 2473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;